import { Component, Input } from '@angular/core';

/** Skeleton loader block(s). variant: text | title | card | row | circle. */
@Component({
  selector: 'er-skeleton',
  template: `
    <div *ngFor="let i of lines"
         class="er-skel"
         [ngClass]="'er-skel--' + variant"
         [style.width]="width || null"
         [style.height]="height || null"
         [style.margin-bottom]="lines.length > 1 ? '10px' : null"></div>`
})
export class ErSkeletonComponent {
  @Input() variant: 'text' | 'title' | 'card' | 'row' | 'circle' = 'text';
  @Input() width: string | null = null;
  @Input() height: string | null = null;
  lines: number[] = [0];
  @Input() set count(n: number | string) {
    const c = Math.max(1, Number(n) || 1);
    this.lines = Array.from({ length: c }, (_, i) => i);
  }
}
